"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListItemDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const WaitListItemDialogForm = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "account" }), (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "listId", controller: "wait-list/list", fetchData: {
                    contractStatus: [types_1.ContractStatus.ACTIVE],
                    isRewardSet: false,
                } })] }));
};
exports.WaitListItemDialogForm = WaitListItemDialogForm;
//# sourceMappingURL=index.js.map